import React from "react";
import { Box } from '@curves/ui-base';
import clsx from "clsx";
import { isEqual} from '@Util/utils';
// required 只有在 direction = row 有效果，在column中給padding畫面不會有變化
const ReadTextField = props => {
    const { className, label, children, textProps = {}, labelProps = {}, onClick, direction = "column", required = false } = props;
    let rowClass = "";
    if (isEqual(direction, "row")) {
        rowClass = "read-text-field-row";
    }
    return (
        <Box className={clsx("read-text-field", rowClass, className)} onClick={onClick}>
            <Box {...labelProps} className={clsx("read-text-field-label", { required }, labelProps.className)}>
                {label}
            </Box>
            <Box {...textProps} className={clsx("read-text-field-text", textProps.className)}>
                {children}
            </Box>
        </Box>
    );
};
export default ReadTextField;
